// Render and control contribute tabs
import React from "react";
import member from "../../session";
import GhostContentPage from "../common/GhostContentPage";

const ContributeNav = (props) => {
  const ContributeAction = (props) => {
    const action = () => {
      props.handleMode(props.action);
      window.history.pushState(
        {},
        "",
        "https://" + location.hostname + "/" + props.action
      );
    };
    const title = props.title;
    let classList = "contribute-nav-tab";
    if (props.selected) {
      classList += " active";
    }
    return (
      <button className={classList} onClick={action}>
        {title}
      </button>
    );
  };
  let membershipAction = "join";
  const title = {
    join: "Join",
    upgrade: "Upgrade",
    donate: "Donate",
    artifacts: "Artifacts",
  };
  if (member) {
    if (props.mode == "join") {
      window.location.href = `/upgrade`;
    }
    membershipAction = "upgrade";
  } else {
    if (props.mode == "upgrade") {
      window.location.href = `/join`;
    }
  }
  document.title = `${title[props.mode]} - Long Now`;

  return (
    <div className="component-nav">
      <div className="page-intro">
        <GhostContentPage
          slug={member ? "contribute-member" : "contribute-visitor"}
        />
      </div>
      <div className="contribute-nav">
        <ContributeAction
          selected={props.mode == membershipAction ? true : false}
          title={title[membershipAction]}
          action={membershipAction}
          handleMode={props.handleMode}
        />
        <ContributeAction
          selected={props.mode == "donate" ? true : false}
          title={title["donate"]}
          action="donate"
          handleMode={props.handleMode}
        />
        <ContributeAction
          selected={props.mode == "artifacts" ? true : false}
          title={title["artifacts"]}
          action="artifacts"
          handleMode={props.handleMode}
        />
      </div>
    </div>
  );
};

export default ContributeNav;
